import { ConnectionRequests } from '../widgets/ConnectionRequests';
import { KernelTerminal } from '../widgets/KernelTerminal';
import { ComputeHoroscope } from '../widgets/ComputeHoroscope';
import { SponsoredWidget } from '../widgets/SponsoredWidget';
import { ProfileMusic } from '../profile/ProfileMusic';
import type { SandboxProfile } from '../../types/sandbox';

interface RightSidebarProps {
  profile: SandboxProfile | null;
}

export function RightSidebar(_props: RightSidebarProps) {
  return (
    <aside className="hidden md:block shrink-0 space-y-3" style={{ width: '240px' }}>
      <div className="space-y-3">
        <KernelTerminal />
        <ProfileMusic />
        <ConnectionRequests />
        <ComputeHoroscope />
        <SponsoredWidget />
      </div>
    </aside>
  );
}
